import type { NotificationListResponseNotificationsItemBasicInfoType } from './notificationListResponseNotificationsItemBasicInfoType';

export type NotificationListResponseNotificationsItemBasicInfo = {
  /** @nullable */
  content?: string | null;
  /** @nullable */
  createdAt?: string | null;
  id: number;
  type: NotificationListResponseNotificationsItemBasicInfoType;
  /** @nullable */
  updatedAt?: string | null;
  userId: number;
};
